import { RefObject, useMemo, useRef } from "react";
import { ViewTableHandle } from "@design-system/ViewTable/ViewTable";
import { useNestedEditorIssueFocus } from "./editor/nested/useNestedEditorIssueFocus";
import { EditorCellFocusTarget } from "./editor/useEditorCellFocus";

interface UseRowIssueNavigationParams {
    rowIds: string[];
    field: EditorCellFocusTarget["field"];
}

interface RowIssueNavigation {
    tableRef: RefObject<ViewTableHandle | null>;
    currentIndex: number;
    navigateTo: (index: number) => void;
}

export function useRowIssueNavigation({
    rowIds,
    field,
}: UseRowIssueNavigationParams): RowIssueNavigation {
    const targets = useMemo(
        () => rowIds.map((rowId): EditorCellFocusTarget => ({ rowId, field })),
        [rowIds, field],
    );
    const tableRef = useRef<ViewTableHandle>(null);
    const { safeIssueIndex, focusIssue } = useNestedEditorIssueFocus({
        issues: targets,
        tableRef,
    });
    return { tableRef, currentIndex: safeIssueIndex, navigateTo: focusIssue };
}
